<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-card-title>
            <div class="headline">{{ heading }}</div>
            <v-spacer></v-spacer>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.value1 }}</td>
                  <td class="text-xs-left">{{ row.item.value2 }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export default {
  props: {
    helpListID: String
  },
  data() {
    return {
      headers: [],
      title: '',
      heading: '',
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    helpListID: function (value) {
      this.getHeaders()
      this.doInit()
    }
  },
  created() {
    this.getHeaders()
    this.doInit()
  },
  methods: {
    getHeaders() {
      this.headers = []
      let IdHeader = {}
      if (this.helpListID === 'defPayBankList') {
        IdHeader = {
          text: 'Bank Abbreviated Name',
          value: 'value1'
        }
        this.title = 'Payment Bank Helplist'
        this.heading = 'Payment Banks List'
      }
      const DescHeader = {
        text: 'Bank Account Name',
        value: 'value2'
      }
      const ActionHeader = {
        text: 'Action',
        align: 'center',
        sortable: false,
        value: ''
      }
      this.headers.push(IdHeader)
      this.headers.push(DescHeader)
      this.headers.push(ActionHeader)
    },
    async doInit() {
      let HelpList = []
      if (this.helpListID === 'defPayBankList') {
        HelpList = this.state.defPayBankList
      }
      this.items = []
      if (HelpList) {
        for (var i in HelpList) {
          const convertList = {
            value1: HelpList[i].value,
            value2: HelpList[i].secondaryValue,
            value3: HelpList[i].thirdValue
          }
          this.items.push(convertList)
        }
      }
    },
    doSelect(Id) {
      this.$emit('doAssign', Id)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.paytMethParam.menu
    },
    state() {
      return this.$store.state.paytMethParam
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
